export default __webpack_public_path__ + "static/movies-855214c57782ab7aa7e851cf9ac39e64.png";